import PreSignPrompt from 'components/auth/PreSignPrompt';
import Modal from 'components/base/Modal';
import ModalContainer from 'components/modals/common/ModalContainer';

import useModal from 'hooks/use-modal';

export default function PreSignModal() {
  const modal = useModal();

  return (
    <ModalContainer modalKey="AUTH_PRE_SIGN">
      <Modal.Content size={2}>
        <PreSignPrompt
          onSign={() => {
            modal.setModal(null);
          }}
        />
      </Modal.Content>
    </ModalContainer>
  );
}
